"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBinaryEventBased = exports.validateAccuracyDetailsParams = exports.validate = exports.warnSettings = exports.validateSettings = exports.warnStep2 = exports.validateStep2 = exports.validateKpiAndThreshold = exports.validateEvaluationSchedule = exports.validatePredictionSchedule = exports.validatePredictionTargets = exports.validateAugurType = exports.validateAugurName = exports.validateKpiThreshold = exports.validateUpdateMeta = exports.validateUpdateAugur = exports.validateAddAugur = exports.validateSchedule = exports.validateTime = void 0;
var lodash_1 = __importDefault(require("lodash"));
var validator_1 = __importDefault(require("validator"));
var moment_1 = __importDefault(require("moment"));
var module_list_1 = require("../constants/module_list");
var enums_1 = require("../constants/enums");
var constants_1 = require("../constants/constants");
var keyPerformanceIndicators_1 = require("../constants/keyPerformanceIndicators");
var accuracyCharts_1 = require("../constants/accuracyCharts");
var isEmpty = function (value) {
    return value === undefined || value === null || value === '';
};
var ALLOWED_PERIODS = [
    enums_1.schedulePeriod.HOURLY,
    enums_1.schedulePeriod.DAILY,
    enums_1.schedulePeriod.WEEKLY,
    enums_1.schedulePeriod.MONTHLY,
];
var timeRe = {
    1: /^[012]$/,
    2: /^([01]?[0-9]|2[0-3])$/,
    3: /^([01]?[0-9]|2[0-3]):$/,
    4: /^([01]?[0-9]|2[0-3]):[0-5]$/,
    5: /^([01]?[0-9]|2[0-3]):[0-5][0-5]$/,
};
var validateTime = function (time, exact) {
    if (exact === void 0) { exact = true; }
    if (exact) {
        // Second check handles special case of 24:00 which moment deems valid, but automatically translates to 00:00
        var timeMoment = (0, moment_1.default)(time, constants_1.timeFormat, true);
        return timeMoment.isValid() && timeMoment.format(constants_1.timeFormat) === time;
    }
    switch (time.length) {
        case 0:
            return true;
        case 1:
        case 2:
        case 3:
        case 4:
            return timeRe[time.length].test(time);
        default: {
            var timeMoment = (0, moment_1.default)(time, constants_1.timeFormat, true);
            return timeMoment.isValid() && timeMoment.format(constants_1.timeFormat) === time;
        }
    }
};
exports.validateTime = validateTime;
var validateSchedule = function (_a, exact) {
    var _b = _a === void 0 ? {} : _a, trigger = _b.trigger, trigDelayed = _b.trigDelayed, period = _b.period, periodValue = _b.periodValue, time = _b.time, mode = _b.mode;
    if (exact === void 0) { exact = true; }
    var errors = {};
    if (!validator_1.default.isIn(mode, [enums_1.scheduleMode.SCHEDULED, enums_1.scheduleMode.MANUAL])) {
        errors.mode = { id: 'newAugur.schedule.error.mode_invalid' };
    }
    if (mode === enums_1.scheduleMode.MANUAL) {
        return errors;
    }
    return errors;
};
exports.validateSchedule = validateSchedule;
var validateAddAugur = function (body) {
    var errors = {};
    if (!validator_1.default.isIn(body.type, module_list_1.moduleTypeValues)) {
        errors.augurType = "AugurType should be in ".concat(module_list_1.moduleTypeValues);
    }
    if (!body.name) {
        errors.augurName = 'AugurName is required';
    }
    switch (body.type) {
        case module_list_1.moduleType.BINARY_NUMERICAL: {
            var settings = body.settings;
            // Validate targets
            if ((settings.predictionTargets &&
                settings.predictionTargets.constructor !== Array) ||
                lodash_1.default.some(settings.predictionTargets, function (x) { return typeof x !== 'string'; })) {
                errors.predictionTargets =
                    'PredictionTargets should be an array of string';
            }
            break;
        }
        default: {
            break;
        }
    }
    return lodash_1.default.pickBy(errors, lodash_1.default.identity);
};
exports.validateAddAugur = validateAddAugur;
var validateUpdateAugur = function (body) {
    var errors = {};
    if (body.name) {
        errors = __assign(__assign({}, errors), validateAugurName(body.name));
    }
    return errors;
};
exports.validateUpdateAugur = validateUpdateAugur;
var validateUpdateMeta = function (body) {
    var errors = {};
    if (body.predictionSchedule)
        Object.assign(errors, (0, exports.validateSchedule)(body.predictionSchedule));
    if (body.evaluationSchedule)
        Object.assign(errors, (0, exports.validateSchedule)(body.evaluationSchedule));
    return lodash_1.default.pickBy(errors, lodash_1.default.identity);
};
exports.validateUpdateMeta = validateUpdateMeta;
var validateKpiThreshold = function (_a) {
    var indicator = _a.indicator, threshold = _a.threshold;
    // @ts-ignore
    var options = keyPerformanceIndicators_1.kpiOptionsGrouped[indicator];
    if (!options) {
        return { id: 'augur.kpi.error.indicator_not_exist' };
    }
    if (+threshold > options.max) {
        return {
            id: 'augur.kpi.error.threshold_max',
            values: { max: options.max },
        };
    }
    if (+threshold < options.min) {
        return {
            id: 'augur.kpi.error.threshold_min',
            values: { min: options.min },
        };
    }
    return '';
};
exports.validateKpiThreshold = validateKpiThreshold;
// const augurNameRegexp = /^[\w\s\d[\]äöüßÄÖÜ]()+$/;
// const augurNameRegexp = /c/;
var augurNameRegexp = /^[a-zA-Z 0-9.,+\-äöüßÄÖÜ()]*$/;
function validateAugurName(augurName) {
    if (isEmpty(augurName)) {
        return { id: 'newAugur.stepOne.error.missing_augur_name' };
    }
    else if (augurName.length < 3 || augurName.length > 65) {
        return { id: 'newAugur.stepOne.error.augur_name_length' };
    }
    else if (!augurNameRegexp.test(augurName)) {
        return {
            id: 'newAugur.stepOne.error.it_can_contain_only_alphanumeric_symbols_and_spaces',
        };
    }
    return undefined;
}
exports.validateAugurName = validateAugurName;
function validateAugurType(values) {
    if (isEmpty(values.datapoolCode)) {
        return { id: 'newAugur.stepOne.error.missing_augur_type' };
    }
    return undefined;
}
exports.validateAugurType = validateAugurType;
function validatePredictionTargets(_a) {
    var predictionTargets = _a.predictionTargets;
    var errors = {};
    if (isEmpty(predictionTargets) || !predictionTargets.length) {
        errors.predictionTargets = {
            id: 'newAugur.stepTwo.error.missing_prediction_targets',
        };
    }
    return errors;
}
exports.validatePredictionTargets = validatePredictionTargets;
function validatePredictionSchedule(_a, exact) {
    var _b = _a.predictionSchedule, predictionSchedule = _b === void 0 ? {} : _b;
    if (exact === void 0) { exact = true; }
    var errors = {};
    if (isEmpty(predictionSchedule.mode)) {
        errors.predictionSchedule = {
            mode: { id: 'newAugur.stepThree.error.missing_prediction_mode' },
        };
    }
    if (predictionSchedule.mode === 'scheduled') {
        var predictionScheduleErrors = (0, exports.validateSchedule)(predictionSchedule, exact);
        if (!lodash_1.default.isEmpty(predictionScheduleErrors)) {
            errors.predictionSchedule = (0, exports.validateSchedule)(predictionSchedule, exact);
        }
    }
    return errors;
}
exports.validatePredictionSchedule = validatePredictionSchedule;
function validateEvaluationSchedule(_a, exact) {
    var evaluationSchedule = _a.evaluationSchedule;
    if (exact === void 0) { exact = true; }
    var errors = {};
    if (!evaluationSchedule) {
        return errors;
    }
    errors.evaluationSchedule = (0, exports.validateSchedule)(evaluationSchedule, exact);
    return errors;
}
exports.validateEvaluationSchedule = validateEvaluationSchedule;
function validateKpiAndThreshold(_a) {
    var learningKpi = _a.learningKpi, learningThreshold = _a.learningThreshold;
    var errors = {};
    if (isEmpty(learningKpi)) {
        errors.learningKpi = { id: 'augur.kpi.error.missing_kpi' };
    }
    if (isEmpty(learningThreshold) && parseFloat(learningThreshold) !== 0) {
        errors.learningThreshold = { id: 'augur.kpi.error.missing_threshold' };
    }
    else {
        errors.learningThreshold = (0, exports.validateKpiThreshold)({
            indicator: learningKpi,
            threshold: learningThreshold,
        });
    }
    return errors;
}
exports.validateKpiAndThreshold = validateKpiAndThreshold;
var validateStep2 = function (values) {
    return validatePredictionSchedule(values);
};
exports.validateStep2 = validateStep2;
var warnStep2 = function (values) {
    return validatePredictionSchedule(values, false);
};
exports.warnStep2 = warnStep2;
function validateSettings(values) {
    return __assign(__assign(__assign({}, validatePredictionSchedule(values)), validateEvaluationSchedule(values)), validateKpiAndThreshold(values));
}
exports.validateSettings = validateSettings;
function warnSettings(values) {
    return __assign(__assign(__assign({}, validatePredictionSchedule(values, false)), validateEvaluationSchedule(values, false)), validateKpiAndThreshold(values));
}
exports.warnSettings = warnSettings;
function validate(values) {
    return __assign(__assign({ augurType: validateAugurType(values), augurName: validateAugurName(values.augurName) }, validatePredictionTargets(values)), validatePredictionSchedule(values));
}
exports.validate = validate;
var validateAccuracyDetailsParams = function (query) {
    var errors = {};
    if (!Object.values(accuracyCharts_1.ACCURACY_DETAILS_TYPE).includes(query.type)) {
        errors.type = "Invalid type '".concat(query.type, "'");
    }
    var limit = +query.limit;
    if (!limit || limit <= 0) {
        errors.limit = 'limit should be positive number';
    }
    return errors;
};
exports.validateAccuracyDetailsParams = validateAccuracyDetailsParams;
function validateBinaryEventBased(values) {
    return __assign(__assign({ augurName: validateAugurName(values), augurType: validateAugurType(values.augurName) }, validatePredictionTargets(values)), validatePredictionSchedule(values));
}
exports.validateBinaryEventBased = validateBinaryEventBased;
//# sourceMappingURL=augur.js.map